import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanySettingComponent } from '../shared/components/company-setting/company-setting.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { RichTextEditorComponent } from 'src/app/shared/components/rich-text-editor/rich-text-editor.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UploadResourcesModule } from '../shared/modules/upload-resources/upload-resources.module';
import { FolderSettingsComponent } from './folder-settings/folder-settings.component';
import { EmailPreviewComponent } from '../shared/components/email-preview/email-preview.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipComponent } from './tooltip/tooltip.component';

@NgModule({
    declarations: [
        CompanySettingComponent,
        EmailPreviewComponent,
        FolderSettingsComponent,
        TooltipComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        RichTextEditorComponent,
        ModalModule,
        UploadResourcesModule,
        DragDropModule,
        ColorPickerModule,
        PopoverModule
    ]
})
export class NavigationModule { }
